import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './blocks/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found/page-not-found.component';
import { AuthenticationGuard } from './core/guards/auth.gaurds';
import { AuthorizedContainerComponent } from './blocks/authorized-container/authorized-container.component';
import { AnynoumouseContainerComponent } from './blocks/anynoumouse-container/anynoumouse-container.component';
import { LandingGuard } from './core/guards/landing.guard';
import { ChangeInvitedUserPasswordComponent } from './features/authentication/change-invited-user-password/change-invited-user-password.component';
import { CompleteRegisterComponent } from './features/authentication/Registration/complete-register/complete-register.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [LandingGuard],
    pathMatch: 'full',
  },
  { 
    path: 'home',
    component: HomeComponent,
    canActivate: [LandingGuard],
  },
  {
    path: 'complete-register/:token',
    redirectTo: 'authentication/complete-register/:token',
    pathMatch: 'full'
  },
  {
    path: 'complete-register',
    redirectTo: 'authentication/complete-register',
    pathMatch: 'full'
  },
  {
    path: 'authentication/complete-register/:token',
    component: CompleteRegisterComponent
  },
  {
    path: 'authentication/complete-register',
    component: CompleteRegisterComponent
  },
  {
    path: 'authentication/complete-register/:otp',
    component: CompleteRegisterComponent
  },
  {
    path: 'authentication',
    loadChildren: () => import('./features/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: '', component: AuthorizedContainerComponent, canActivate: [AuthenticationGuard],
    children: [
      {
        path: 'opportunities',
        loadChildren: () => import('./features/opportunities/opportunities.module').then(m => m.OpportunitiesModule)
      },
      {
        path: 'kyc',
        loadChildren: () => import('./features/kyc/kyc.module').then(m => m.KycModule)
      },
      {
        path: 'investment',
        loadChildren: () => import('./features/investments/investments.module').then(m => m.InvestmentsModule)
      },
      {
        path: 'wallet',
        loadChildren: () => import('./features/wallet/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./features/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'payment',
        loadChildren: () => import('./features/noon-payment/noon-payment.module').then(m => m.NoonPaymentModule)
      },
    ]
  },
  {
    path: '', component: AnynoumouseContainerComponent, children: [
      {
        path: 'faq',
        loadChildren: () => import('./features/faq/faq.module').then(m => m.FaqModule)
      },
      {
        path: 'authentication/change-password',
        component: ChangeInvitedUserPasswordComponent,
      }
    ]
  },

  {
    path: '**',
    component: PageNotFoundComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
